import authHttp, { API_ROOT } from '../auth-http'

export const NewsService = {
    getAll(data) {
        let param = ''
        if (data.size !== undefined) {
            if (param === '') {
                param = param + '?size=' + data.size
            } else {
                param = param + '&size=' + data.size
            }
        }
        if (data.page !== undefined) {
            if (param === '') {
                param = param + '?page=' + data.page
            } else {
                param = param + '&page=' + data.page
            }
        }
        return authHttp.get(`${API_ROOT}/public/news/${param}`)
    },
    getById(id) {
        return authHttp.get(`${API_ROOT}/public/news/${id}`)
    }
}

export default NewsService